import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { getTaskTypes } from "../../actions/userActions/taskTypeAction";
import { SIZE_OF_PAGE } from "../../actions/types";
import DynamicTable from "../reuse_components/DynamicTable";
import SearchInput from "../subComponents/search/SearchInput";
import Heading6Regular from "../designSystem/Heading6Regular";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import CustomPagination from "../subComponents/pagination/CustomPagination";
import thIcon from "../../assets/images/thIcon.svg";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import ItemsPerPageSelector from "../subComponents/pagination/ItemsPerPageSelector";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
import { t } from "../../locales/translate";

function TaskTypes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isExpanded, setIsExpanded] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [query, setQuery] = useState("");
  const [previousQuery, setPreviousQuery] = useState("");
  const [taskTypesData, settaskTypesData] = useState([]);
  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  const firstPage = 1;
  const [itemsPerPage, setItemsPerPage] = useState(10);
  useEffect(() => {
    const pageNumber = currentPage;

    if (query !== previousQuery) {
      setCurrentPage(1);
    }
    dispatch(getTaskTypes(pageNumber, itemsPerPage, query));
    setPreviousQuery(query);

  }, [currentPage, query]);
  const taskTypes = useSelector((state) => state.task_types_reducer.taskTypes);
  const totalPages = taskTypes?.totalPages || 0;
  const totalItems = taskTypes?.totalCount || 0;
  const permissions = JSON.parse(localStorage.getItem("permissionsList"));
  const isLoading = useSelector((state) => state.task_types_reducer.isTaskTypeLoading);

  const taskTypeData = taskTypes && taskTypes.result;
  useEffect(() => {
    const tasktypeData = taskTypeData?.map((taskTypes) => ({
      ...taskTypes,
      status: (
        <span className={taskTypes.active ? "status-badge-active" : "status-badge-inactive"}>
          {taskTypes.active ? "Active" : "Inactive"}
        </span>
      ),
    }));
    settaskTypesData(tasktypeData);
  }, [taskTypes]);


  const columns = [
    { label:`${t("name")}`, accessor: "name" },
    { label:`${t("description")}`, accessor: "description" },
    { label: `${t("status")}`, accessor: "status" },
  ];
  const handleItemsPerPageChange = (value) => {
    const pageNumber = firstPage;
    dispatch(getTaskTypes(pageNumber, value, query));
    setItemsPerPage(value);
    setCurrentPage(1);
  };
  const handleSearchChange = (e) => {
    setQuery(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>
    <div>
      <LoadingOverlay isVisible={isLoading} />
      <div className="main-container">
        <div className="content-wrapper">
          <div className="pagination">
            <SearchInput
              placeholder="Search"
              onChange={handleSearchChange}
              value={query}
            />
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ minWidth: '80px', marginRight: '10px' }}>
                <ItemsPerPageSelector
                  value={itemsPerPage}
                  onChange={handleItemsPerPageChange}
                />
              </div>
              <CustomPagination
                currentPage={currentPage}
                totalItems={totalItems}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page)}
              />

            </div>
          </div>

        </div>
        <DynamicTable
          data={taskTypesData}
          columns={columns}
          permissions={permissions}
          showPagination={totalItems > 0}
          currentPage={currentPage}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      </div>
      </div>
    </>
  );
}

export default TaskTypes;
